import { render, staticRenderFns } from "./Plantchart.vue?vue&type=template&id=5fac103d&"
import script from "./Plantchart.vue?vue&type=script&lang=js&"
export * from "./Plantchart.vue?vue&type=script&lang=js&"
import style0 from "./Plantchart.vue?vue&type=style&index=0&id=5fac103d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports